import React from 'react'
import { salesDeckList } from '../content/salesDecks'
import { SeoHead } from '../components/landing/SeoHead'
import { siteOrigin } from '../components/landing/marketingPages'
import '../styles/salesDecks.css'

export const SalesDeckIndexPage: React.FC = () => (
  <div className="sales-deck-page">
    <SeoHead
      title="NexusWorkforce360 Sales Decks"
      description="Internal NexusWorkforce360 segment sales decks."
      canonicalUrl={`${siteOrigin}/sales-decks`}
      noindex
    />
    <header className="sales-deck-topbar">
      <a href="/" className="sales-deck-back">NexusWorkforce360</a>
      <a className="btn btn-secondary" href="/login">Sign in</a>
    </header>

    <main className="sales-deck-main">
      <section className="sales-deck-index-hero">
        <p className="sales-deck-kicker">Internal sales assets</p>
        <h1>NexusWorkforce360 segment sales decks</h1>
        <p>
          Interactive and printable, source-controlled decks for positioning NexusWorkforce360 as a Workforce Network OS and workforce supply chain control layer.
        </p>
      </section>

      <section className="sales-deck-index-grid" aria-label="Available sales decks">
        {/* Interactive Deck - Featured First */}
        <article className="sales-deck-index-card" key="interactive">
          <div>
            <span className="badge" style={{ backgroundColor: '#0d9488', color: '#f0fdfa', padding: '0.25rem 0.75rem', borderRadius: '0.375rem', fontSize: '0.75rem', fontWeight: 'bold', marginBottom: '0.5rem', display: 'inline-block' }}>FEATURED</span>
            <h2>Interactive NexusWorkforce360 Sales Deck</h2>
            <p>Live, browser-based presentation with interactive simulators and real-time demonstrations.</p>
          </div>
          <dl>
            <div>
              <dt>Core promise</dt>
              <dd>Show the Workforce Network OS in action with live geofence validators, multi-tenant bridges, and timesheet reconciliation.</dd>
            </div>
            <div>
              <dt>Best use case</dt>
              <dd>Real-time executive demos, interactive pitches, and hands-on platform walkthroughs.</dd>
            </div>
          </dl>
          <a className="btn btn-primary" href="/sales-decks/interactive">Open deck</a>
        </article>

        {salesDeckList.map((deck) => (
          <article className="sales-deck-index-card" key={deck.id}>
            <div>
              <span>{deck.targetBuyer}</span>
              <h2>{deck.title}</h2>
              <p>{deck.corePromise}</p>
            </div>
            <dl>
              <div>
                <dt>Core promise</dt>
                <dd>{deck.corePromise}</dd>
              </div>
              <div>
                <dt>Best use case</dt>
                <dd>{deck.bestUseCase}</dd>
              </div>
            </dl>
            <a className="btn btn-primary" href={`/sales-decks/${deck.slug}`}>Open deck</a>
          </article>
        ))}
      </section>
    </main>
  </div>
)
